import React, { Component } from "react";
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import AtividadeComponent from "../atividades/AtividadeComponent";

import AtividadeService from "../../app/service/AtividadeService";

import { AuthContext } from '../../main/ProvedorAutenticacao'

class Atividades extends Component {
	constructor(props) {
		super(props);

		this.state = {
			atividades: [],
			modalAtividades: false,
			displayAtividade: false,
			atividadeSelecionada: false,
			historicoAtividade: null,
			atividade: null,
		}

		this.atividadeService = new AtividadeService();
		
		this.linkAbrirAtividade = this.linkAbrirAtividade.bind(this);
	}

	fecharModal(name) {
		this.setState({
				[`${name}`]: false
		});
	}

	linkAbrirAtividade(rowData) {
		return(
			<React.Fragment>
				<a onClick={() => this.consultarAtividade(rowData)} 
						style={{cursor: 'pointer', color: 'blue'}}>{rowData.titulo}</a>
			</React.Fragment>
		);
	}

	consultarAtividade = async (atividade) => {
		this.setState({openSpinner: true});
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.atividadeService.consultarAtividadeCustom(atividade.codigo,usuarioLogado.empresa.codigo,usuarioLogado.codigo)
			.then(response => {
				this.setState({atividadeSelecionada: response.data});
				this.setState({
					atividadeSelecionada: response.data,
					displayAtividade: true,
					openSpinner: false
				});
			})
	};

	consultarHistorico = async (codigo) => {
		await this.atividadeService.consultarHistorico(codigo)
			.then(response => {
				this.setState({historicoAtividade: response.data});
			}).catch(error => {
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
			})
  }

	setModalAtividades(flag) {
		this.setState({displayAtividade: flag});
	}

	componentDidUpdate(prevProps){
		if(prevProps.atividades !== this.props.atividades){
			this.setState({atividades: this.props.atividades});
		}
	}

	render() {
			const { visible, onHide } = this.props;
			return(
				<>

					<Toast ref={(el) => this.toast = el} />
					<Backdrop
						sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={this.state.openSpinner}>
						<CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
					</Backdrop>

					<AtividadeComponent
							visible={this.state.displayAtividade}
							atividade={this.state.atividadeSelecionada}
							historico={this.state.historicoAtividade}
							onHide={() => this.setModalAtividades(false)}
					/>
					<Dialog header="Atividade(s)"
									visible={visible}
									style={{ width: '43vw' }}
									footer={
										<div>
											<Button
												label="Fechar"
												icon="pi pi-times"
												className="p-button-text p-button-secondary"
												onClick={onHide}
											/>
										</div>
									} 
									onHide={onHide}>
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group">
												<strong>Atividades da Publicação</strong>
											</div>
										</div>
									</div>
									<div className="row">
									<div className="col-sm-12">
										<div className="form-group">
											<DataTable value={this.state.atividades} 
																	emptyMessage=" "
																	size="small">
												<Column body={this.linkAbrirAtividade} exportable={false} style={{ minWidth: '8rem' }}header="Atividade"></Column>
												<Column field="dtLimite" header="Data Limite"></Column>
												<Column field="status.status" header="Status"></Column>
												<Column field="responsaveis" header="Responsáveis"></Column>
											</DataTable>
										</div>
									</div>
								</div>
					</Dialog>
				</>
			);
	}
}
Atividades.contextType = AuthContext;
export default Atividades;